import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[arrayControl]'
})
export class ArrayControlDirective implements OnChanges{

  //disable the control which is not selected in execute and exempt form 
  // and also reset the value when changes

  @Input() condition : any;
  
  constructor(private ngControl : NgControl) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.disableControl(changes.condition.firstChange)
  }

  disableControl (changestate:boolean) {
    const action = this.condition[0] === this.condition[1] ? 'enable' : 'disable';
    this.ngControl.control[action]();
    if(!changestate){
      if(this.condition[0] === this.condition[1]){
        this.ngControl.reset(true)
      }else{
        this.ngControl.reset(false)
      }
    }
  }
}